export const getGuid = async ({ derivativeId, accessToken  }) => {
    if (!accessToken || !derivativeId) {
        throw new Error('Missing required parameters for fetching guid');
    }

    // Prepare the request headers
    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    });

    // Prepare the request object
    const request = new Request(`https://developer.api.autodesk.com/modelderivative/v2/regions/eu/designdata/${derivativeId}/metadata`, {
        method: 'GET',
        headers: requestHeaders
    });
    try {
        // Make the fetch request
        const response = await fetch(request);

        // Check if the response is okay
        if (!response.ok) {
            throw new Error(`HTTP error from Guid API Status: ${response.status} ${response.statusText}`);
        }
        const guid = await response.json();
        console.log('Fetched guid:', guid);
        return guid;


    } catch (error) {
        // Log and rethrow any errors encountered
        console.error('Error fetching fetching guid:', error);
        throw error;
    }
};
